import React from "react";
import FieldModal from "../../../../components/modals/fieldModal";
import InputField from "../../../../components/inputs/inputField";
import ToggleField from "../../../../components/inputs/toggleField";

class AddUsersToSharePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            newEmail: '',
            enableExternalSharing: props.page.enableExternalSharing || false,
            shareList: props.page.sharedWith ? props.page.sharedWith : [],
            error: ''
        }
    }

    validateEmail = (newEmail) => {
        const re = /\S+@\S+\.\S+/;
        return re.test(newEmail);
    }

    addShare = () => {
        const { newEmail, shareList } = this.state;
        const isValidEmail = this.validateEmail(newEmail);
        if (isValidEmail) {
            const existingEmail = shareList.find(e => e.email === newEmail.toLowerCase());
            if (existingEmail) {
                // If exists, set deleted to false, preserve _id and other fields
                existingEmail.deleted = false;
                this.setState({ shareList, newEmail: '', error: '' }, () => {
                    this.props.sharePage({ enableExternalSharing: this.state.enableExternalSharing, sharedWith: this.state.shareList });
                });
            } else {
                // If doesn't exist, push new record
                shareList.push({ email: newEmail.toLowerCase(), fullName: '', deleted: false });
                this.setState({ shareList, newEmail: '', error: '' }, () => {
                    this.props.sharePage({ enableExternalSharing: this.state.enableExternalSharing, sharedWith: this.state.shareList });
                });
            }
        } else {
            this.setState({ error: 'Invalid email' });
        }
    }

    removeShare = (index) => {
        const { shareList } = this.state;
        shareList[index].deleted = true;
        this.setState({ shareList }, () => {
            this.props.sharePage({ enableExternalSharing: this.state.enableExternalSharing, sharedWith: this.state.shareList });
        });
    }
    render() {
        const { orgId, eventId, page } = this.props;
        const { shareList, error, enableExternalSharing, newEmail } = this.state;
        return <FieldModal
            size="small"
            isOpen={this.props.isOpen}
            modalTitle={"Manage Page Sharing"}
            bodyHeaderText={'Manage email addresses that can access this page.'}
            bodyContent={() => {
                return (
                    <div>
                        <ToggleField
                            label={'Enable External Sharing'}
                            checked={this.state.enableExternalSharing}
                            onChange={(e) => this.setState({ enableExternalSharing: e.target.checked }, () => {
                                this.props.sharePage({ enableExternalSharing: this.state.enableExternalSharing, sharedWith: this.state.shareList })
                            })}
                            icons={null}
                        />

                        {enableExternalSharing && (
                            <a target="_blank" href={`https://planner.simple.events/external/${orgId}/events/${eventId}/pages/${page._id}`}><h3 className="mb-20">Share Link</h3></a>
                        )}

                        <div className="flex jcc mb-20">

                            <InputField
                                label={'Email to share with'}
                                type={'email'}
                                value={newEmail}
                                classes="mb-0"
                                onChange={(e) => this.setState({ newEmail: e.target.value })}
                                placeholder={'Enter email'}
                                errorTrigger={error !== ''}
                                errorMessage={error}

                            />
                            <button className="mt-a mb-5 neu ml-10" onClick={() => this.addShare()}>
                                Add
                            </button>
                        </div>
                        <div className="flex column">
                            <h3 className="mb-10">Shared With:</h3>
                            {shareList.filter(user => !user.deleted).length > 0 ? shareList.map((user, index) => {
                                if (user.deleted) return null;
                                return <div key={index} className="flex aic jcsb mb-15"><h4>{user.email}</h4><button onClick={() => this.removeShare(index)} className="neu p-7"><i className="las la-times"></i></button></div>
                            }) : <div className="flex aic jcc mb-15"><h4>No external emails</h4></div>}
                        </div>
                    </div>
                );
            }}
            toggle={this.props.toggle}
            actionButtonDisabled={this.props.submitting}
            cancelButtonLabel={'Done'}
            isDelete={false}
        />
    }
}

export default AddUsersToSharePage;
